import { render, staticRenderFns } from "./seacher.vue?vue&type=template&id=2ce15562&scoped=true"
import script from "./seacher.vue?vue&type=script&lang=js"
export * from "./seacher.vue?vue&type=script&lang=js"
import style0 from "./seacher.vue?vue&type=style&index=0&id=2ce15562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce15562",
  null
  
)

export default component.exports